export const SEARCH_PRODUCTS = 'product';
export const SORT_PRODUCT_DATE = 'product_date';
export const CLEAR_PRODUCT_DATE = 'clear_sorting';
